import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, TypeBadge, StatusBadge, Empty } from "../components/common";
import { ClipboardList, Zap } from "lucide-react";

export default function MyResponses() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/responses/me").then(({ data }) => setRows(data));
  }, []);

  return (
    <div>
      <PageHeader eyebrow="SMME" title="My Responses"
        subtitle="Track every opportunity you have responded to and its progress." />
      {rows.length === 0 ? (
        <Empty icon={ClipboardList} title="No responses yet" subtitle="Respond to opportunities to see them here." />
      ) : (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr className="text-left text-slate-500">
                <th className="px-5 py-3 font-semibold">Opportunity</th>
                <th className="px-5 py-3 font-semibold">Type</th>
                <th className="px-5 py-3 font-semibold">Submitted</th>
                <th className="px-5 py-3 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((r) => (
                <tr key={r.id} data-testid={`response-row-${r.id}`} className="hover:bg-slate-50">
                  <td className="px-5 py-4 font-medium text-slate-900">
                    <div className="flex items-center gap-2">
                      {r.opportunity_title}
                      {r.auto && <Zap className="h-3.5 w-3.5 text-[#F2B50C]" title="Auto-response" />}
                    </div>
                  </td>
                  <td className="px-5 py-4"><TypeBadge type={r.opportunity_type} /></td>
                  <td className="px-5 py-4 text-slate-500">{(r.created_at || "").slice(0, 10)}</td>
                  <td className="px-5 py-4"><StatusBadge status={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
